import type { CloudpackConfig } from '@ms-cloudpack/common-types';
import type { TelemetryClient } from '@ms-cloudpack/telemetry';
import spawn from 'cross-spawn';

/**
 * Runs the pre-requisites specified in the given Cloudpack config
 * @param config - The Cloudpack config of containing a list of prerequisites to run
 */
export async function runPrerequisites(options: {
  config: CloudpackConfig | undefined;
  appPath: string;
  telemetryClient: TelemetryClient;
}): Promise<void> {
  const { config, appPath, telemetryClient } = options;

  await telemetryClient.tracer.startActiveSpan('RUN_PREREQUISITES', () => {
    const dependsOn = config?.dependsOn;
    if (dependsOn) {
      for (const [command, args] of dependsOn) {
        spawn.sync(command, args, { stdio: 'inherit', cwd: appPath, shell: true });
      }
    }
  });
}
